import SortableHeading from "@/components/table/SortableHeading"
import type { VtsSortBy } from "@/models/VtsLogSearch"
import type { TdHTMLAttributes } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { useVtsLogStore } from "../store"

interface Props {
	sort: VtsSortBy
	text: string
}

const SortableVtsHeading: ReactiveComponent<Props, TdHTMLAttributes> = (props, { attrs }) => {
	const store = useVtsLogStore()

	return () => (
		<SortableHeading
			direction={
				store.requestOptions.sortBy === props.sort && !!store.requestOptions.sortDirection
					? store.requestOptions.sortDirection
					: null
			}
			setDirection={(dir) => {
				store.requestOptions.sortBy = props.sort
				store.requestOptions.sortDirection = dir
			}}
			align="center"
			{...attrs}
		>
			{props.text}
		</SortableHeading>
	)
}

export default defineComponent(SortableVtsHeading, inferProps<Props>())
